<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M81.3008 36.1079C86.8137 36.1079 91.2848 40.579 91.2848 46.0919V95.4463C91.2848 98.8101 89.6178 101.793 87.0638 103.597"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.0279 103.787H46.693C41.1801 103.787 36.709 99.3162 36.709 93.8033V44.4489C36.709 38.9359 41.1801 34.4648 46.693 34.4648C46.693 34.4648 85.7598 38.0846 78.3774 20.0395C70.9951 1.99452 37.7747 28.2435 73.8647 45.0561"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M54.4082 49.7297V92.9282"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.1953 49.7297V92.9282"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M75.9844 49.7297V92.9282"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.5966 114.033C49.6746 114.033 51.3592 112.349 51.3592 110.271C51.3592 108.193 49.6746 106.508 47.5966 106.508C45.5186 106.508 43.834 108.193 43.834 110.271C43.834 112.349 45.5186 114.033 47.5966 114.033Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.4091 114.033C84.4871 114.033 86.1717 112.349 86.1717 110.271C86.1717 108.193 84.4871 106.508 82.4091 106.508C80.3311 106.508 78.6465 108.193 78.6465 110.271C78.6465 112.349 80.3311 114.033 82.4091 114.033Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
